import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractorRateLimitRoute } from '../../routing'

export class ExtractorRateLimitPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ExtractorRateLimitRoute />
            </Fragment>
        )
    }
}
